import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card shadow mb-4" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "float-end d-flex align-items-center gap-3" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center mb-3 rounded px-3 py-2 border-start border-3 border-info bg-info bg-opacity-25"
}
const _hoisted_7 = {
  key: 0,
  class: "text-dark small"
}
const _hoisted_8 = {
  key: 1,
  class: "text-dark small"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParameterHelp = _resolveComponent("ParameterHelp")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameters, (definition, name) => {
      return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.$t(`parameters.${name}.name`)) + " ", 1),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.foundCount(name) > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-link btn-sm p-0 text-decoration-none",
                    onClick: ($event: any) => (_ctx.foundValues!.show(name))
                  }, [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "fas fa-magic me-2" }, null, -1)),
                    _createTextVNode(_toDisplayString(_ctx.foundLabel(name)), 1)
                  ], 8, _hoisted_4))
                : _createCommentVNode("", true),
              _createVNode(_component_ParameterHelp, {
                estateType: _ctx.estateType,
                name: name
              }, null, 8, ["estateType", "name"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isPrefilled(name))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fas me-2", definition.prefilledFromSources ? 'fa-magic text-primary' : 'fa-info-circle text-info'])
                  }, null, 2),
                  (definition.prefilledFromSources)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" Převzato z ", -1),
                        _createElementVNode("strong", null, "podkladů", -1),
                        _createTextVNode(" — ověřte prosím správnost údaje. ", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("Předvyplněno z ", -1),
                        _createElementVNode("strong", null, "RÚIAN", -1),
                        _createTextVNode(" — doporučujeme ověřit správnost údaje.", -1)
                      ]))])),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-close btn-close-sm ms-auto",
                    onClick: ($event: any) => (_ctx.dismissPrefilledHint(name)),
                    "aria-label": "OK"
                  }, null, 8, _hoisted_9)
                ]))
              : _createCommentVNode("", true),
            (_ctx.$t(`descriptions.${_ctx.estateType}.${name}`))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t(`descriptions.${_ctx.estateType}.${name}`)), 1))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.resolveControl(definition.type)), _mergeProps({ ref_for: true }, definition, {
              "parameter-id": name,
              value: _ctx.values[name],
              onInput: ($event: any) => (_ctx.valueUpdated(name, $event)),
              onValidated: ($event: any) => (_ctx.valueValidated(name, $event)),
              key: name + _ctx.clearCounter,
              label: _ctx.$t(`parameters.${name}.name`),
              validate: _ctx.validate && ! _ctx.validParameters[name]
            }), null, 16, ["parameter-id", "value", "onInput", "onValidated", "label", "validate"]))
          ])
        ])
      ]))
    }), 256))
  ]))
}